import { Environment, Network } from 'relay-runtime';
import { fg } from '@atlaskit/platform-feature-flags';
import { getDefaultRelayEnvironmentConfig } from '@atlassian/relay-environment-config';
import { captureErrors, isUnauthenticated } from '@atlassian/relay-errors';
import { fetch } from '@atlassian/relay-fetch/multi-fetch';
import { fetchFn as legacyFetch } from '@atlassian/relay-network';
import { SSRQueryResponseCache } from '@atlassian/relay-query-responses';
import { subscribe } from '@atlassian/relay-subscription';
var getLoggingAndMetricsHelper = function getLoggingAndMetricsHelper() {
  return {
    logNonBreakingErrors: function logNonBreakingErrors() {},
    logError: function logError() {},
    logErrorRetry: function logErrorRetry() {},
    logQueryFallbackToPost: function logQueryFallbackToPost() {}
  };
};

/**
 * @deprecated use useRelayEnvironment() from react-relay to get this environment instead of using it directly
 */
export var __INTERNAL_RELAY_ENVIRONMENT__DO_NOT_USE_THIS_DIRECTLY__ = new Environment(getDefaultRelayEnvironmentConfig({
  network: Network.create(function (request, variables, cacheConfig) {
    // use new fetch if the feature flag is enabled
    if (fg('platform_environment_for_atlassian_studio') || fg('relay_store_for_platform_packages_in_confluence')) {
      return fetch(request, variables, cacheConfig, {
        getLoggingAndMetricsHelper: getLoggingAndMetricsHelper,
        withErrorHandling: function withErrorHandling(source) {
          return source;
        },
        validateResponse: function validateResponse(request, response) {
          var errors = 'errors' in response ? response.errors : undefined;
          if (errors != null) {
            var _response$extensions;
            var requestId = response === null || response === void 0 || (_response$extensions = response.extensions) === null || _response$extensions === void 0 || (_response$extensions = _response$extensions.gateway) === null || _response$extensions === void 0 ? void 0 : _response$extensions.request_id;
            captureErrors(errors, {
              operationName: request.name,
              requestId: requestId
            });
            if (isUnauthenticated(errors)) {
              return false;
            }
          }
          return true;
        },
        onInvalidResponse: function onInvalidResponse() {},
        queryResponseCache: new SSRQueryResponseCache({
          cacheName: 'relay-cache/v2/AGG',
          size: Infinity,
          ttl: Infinity
        }),
        isServer: globalThis.__SERVER__
      });
    }

    // fallback to currnt fetch
    return legacyFetch(request, variables, cacheConfig);
  }, subscribe)
}));